// Watch branch + unit <select>s.

// Hide/show cards based on their data attributesimport { Controller } from "@hotwired/stimulus"

// Usage:
// <div data-controller="soldier-filters">
//   <select data-soldier-filters-target="branchFilter"
//           data-action="change->soldier-filters#filter">
//   ...
//   </select>
//
//   <select data-soldier-filters-target="unitFilter"
//           data-action="change->soldier-filters#filter">
//   ...
//   </select>
//
//   <div data-soldier-filters-target="card"
//        data-branches="army navy"
//        data-units="1st-regiment company-a">
//     ...
//   </div>
// </div>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "branchFilter", "unitFilter", "counter"]

   connect() {
    // Initialize the counter on page load
    this.updateCounter(this.cardTargets.length)
  }
  filter() {
    const branch = this.selectedValue(this.branchFilterTarget)
    const unit   = this.selectedValue(this.unitFilterTarget)

    console.log("[soldier-filters] filter called", { branch, unit }) // <- add this
    
    let visibleCount = 0

  
    this.cardTargets.forEach((card) => {
      const cardBranches = (card.dataset.branches || "").split(/\s+/)
      const cardUnits    = (card.dataset.units || "").split(/\s+/)

      const branchMatches = !branch || cardBranches.includes(branch)
      const unitMatches   = !unit   || cardUnits.includes(unit)

      const show = branchMatches && unitMatches
      card.classList.toggle("d-none", !show)

      if (show) visibleCount += 1
    })

       this.updateCounter(visibleCount)
  }
  reset() {
    if (this.hasBranchFilterTarget) this.branchFilterTarget.value = ""
    if (this.hasUnitFilterTarget)   this.unitFilterTarget.value   = ""

    this.cardTargets.forEach((card) => {
      card.classList.remove("d-none")
    })

    this.updateCounter(this.cardTargets.length)
  }

  selectedValue(selectElement) {
    return selectElement ? (selectElement.value || "") : ""
  }

  updateCounter(count) {
    if (!this.hasCounterTarget) return
    this.counterTarget.textContent = count
  }
}
